import store from '@/store';
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { GlobalOverlayConfig } from '@/ts/interfaces/OverlayInterfaces';
import { Mutations } from '@/ts/store/Constants';

@Module({name: 'GlobalOverlay', namespaced: true})
export default class GlobalOverlay extends VuexModule {
    public globalOverlayVisibility: boolean = false;
    public globalOverlayConfig: GlobalOverlayConfig = {};

    @Mutation
    public RESET_GLOBAL_OVERLAY_STORE_STATE() {
        this.globalOverlayVisibility = false;
        this.globalOverlayConfig     = {};
    }

    get getGlobalOverlayConfig(): GlobalOverlayConfig {
        return this.globalOverlayConfig;
    }

    @Action
    public SUBMIT_GLOBAL_OVERLAY_VISIBILITY(visibility: boolean) {
        store.commit(Mutations.SET_GLOBAL_OVERLAY_VISIBILITY_STATUS, visibility);
    }

    @Action
    public SUBMIT_GLOBAL_OVERLAY_CONFIG(config: GlobalOverlayConfig) {
        store.commit(Mutations.SET_GLOBAL_OVERLAY_CONFIG, config);
    }

    @Mutation
    public SET_GLOBAL_OVERLAY_VISIBILITY(visibility: boolean) {
        this.globalOverlayVisibility = visibility;
    }

    @Mutation
    public SET_GLOBAL_OVERLAY_CONFIG(config: GlobalOverlayConfig) {
        this.globalOverlayConfig = config;
    }
}
